/**
 * JSX icon.
 * 
 * IMPORTANT : to use svg with React, don't forget to convert <svg> attributes like 'sketch:type' TO 'sketchType', 
 * 'xmlns:xlink' TO 'xmlnsXlink' or 'xlink:href' TO 'xlinkHref' otherwise it won't work.
 */
const GuitarIcon = () => {
    return(
        <svg id="sectionIcon" version="1.1" viewBox="0 0 32 32" xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <path d="M29.7,5.5c-0.4-0.4-1-0.4-1.4,0l-2.7,2.7l-0.6-0.6l-0.6-0.6L27,4.3c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0l-2.8,2.8  c-1.4-1-3.1-1.4-4.7-1.1c-2,0.3-3.7,1.5-4.6,3.2c-0.5,0.9-1.2,1.5-2.2,1.9l-3.9,1.5c-2.4,1-4.1,3-4.7,5.5C2.1,19.4,3,22.2,5,24.2  l3.4,3.4C9.9,29.1,12,30,14.2,30c0.5,0,1.1-0.1,1.6-0.2c2.6-0.5,4.6-2.2,5.5-4.7l1.5-3.9c0.4-0.9,1-1.7,1.9-2.2  c1.8-1,2.9-2.6,3.2-4.6c0.2-1.7-0.2-3.4-1.1-4.7L29.7,7C30.1,6.6,30.1,5.9,29.7,5.5z M14.1,23.5c-0.2,0.2-0.5,0.3-0.7,0.3  s-0.5-0.1-0.7-0.3L9,19.8c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l3.7,3.7C14.5,22.5,14.5,23.1,14.1,23.5z M20.9,17.1  c-0.7,0.7-1.7,1.1-2.7,1.1s-2-0.4-2.7-1.1c-0.7-0.7-1.1-1.7-1.1-2.7s0.4-2,1.1-2.7c1.5-1.5,4-1.5,5.5,0c0.7,0.7,1.1,1.7,1.1,2.7  S21.6,16.3,20.9,17.1z"/>
        </svg>
    );
}

export default GuitarIcon;